// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-15f8350e] .el-descriptions__header{margin-top:20px;margin-bottom:4px}[data-v-15f8350e] .el-dialog__footer{text-align:center}", ""]);
// Exports
module.exports = exports;
